import { Component, OnInit, OnDestroy } from '@angular/core';
import { IViewSpecs, ViewSpecs, INavParams } from 'src/app/classes/def/nav-params/general';
import { ModalController } from '@ionic/angular';
import { MediaUtilsService } from 'src/app/services/media/media-utils';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { ParamHandler } from 'src/app/classes/general/params';
import { EAppIcons, EAppIconsStandard } from 'src/app/classes/def/app/icons';

export interface IPhotoFrameNavParams {
  description?: string;
  title: string;
  photoUrl: string;
  auxPhotoUrls?: string[];
  sharePhoto: boolean;
  isDataUrl: boolean;
  /**
   * add the functionality to change the photo (e.g. profile picture)
   */
  uploadPhoto: boolean;
  expanded?: boolean;
  /**
   * the callback on select photo
   */
  uploadPhotoFn?: () => any;
}

@Component({
  selector: 'modal-photo-frame',
  templateUrl: './photo-frame.component.html',
  styleUrls: ['./photo-frame.component.scss'],
})
export class PhotoFrameViewComponent implements OnInit, OnDestroy {
  description: string = "";
  descriptionLines: string[];
  title: string = "";
  /**
   * file/data URI
   */
  photoUrl: string = null;
  selectAll: boolean = false;

  zoom: boolean = false;
  isDataUrl: boolean = false;
  vs: IViewSpecs = ViewSpecs.getDefault();

  enable = {
    share: false,
    upload: false
  };

  withButtons: boolean = false;

  params: IPhotoFrameNavParams = null;

  np: INavParams = null;

  appIcons = EAppIcons;
  appIconsStandard = EAppIconsStandard;

  constructor(
    public modalCtrl: ModalController,
    public mediaUtils: MediaUtilsService,
    public uiext: UiExtensionService
  ) {

  }

  ngOnInit() {
    let hasParams: boolean = ParamHandler.checkParams(this.np);

    if (hasParams) {
      let np: INavParams = ParamHandler.getParams(this.np);
      let params: IPhotoFrameNavParams = np.params;
      this.params = params;

      if (np.view) {
        this.vs = np.view;
      }

      console.log(np);

      this.description = params.description;

      this.title = params.title;
      this.photoUrl = params.photoUrl;
      this.enable.share = params.sharePhoto;
      this.isDataUrl = params.isDataUrl;
      this.enable.upload = params.uploadPhoto;


      let keys: string[] = Object.keys(this.enable);

      for (let i = 0; i < keys.length; i++) {
        let key: string = keys[i];
        if (this.enable[key]) {
          this.withButtons = true;
        }
      }
    }
  }

  ngOnDestroy() {

  }

  dismiss() {
    setTimeout(() => {
      this.modalCtrl.dismiss(null).then(() => {
      }).catch((err: Error) => {
        console.error(err);
      });
    }, 1);
  }

  uploadPhoto() {
    if (this.params.uploadPhotoFn != null) {
      this.params.uploadPhotoFn();
      this.dismiss();
    }
  }

  zoomIn() {
    this.zoom = true;
  }

  zoomOut() {
    this.zoom = false;
  }
}
